import { render } from "./ListaSinistrosCobrancaView.vue?vue&type=template&id=1cfbcf20&scoped=true"
import script from "./ListaSinistrosCobrancaView.vue?vue&type=script&lang=js"
export * from "./ListaSinistrosCobrancaView.vue?vue&type=script&lang=js"

import "./ListaSinistrosCobrancaView.vue?vue&type=style&index=0&id=1cfbcf20&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfbcf20"]])

export default __exports__